<template>
  <div
    class="m-auto mt-16 w-[250px] max-w-[250px] shrink basis-1/5 md:m-0 md:w-auto"
  >
    <OnboardingChart
      :is-fetching-pending
      :on-going-required-tasks-amount
      :required-task-amount
    />
    <OnboardingHelp :is-fetching-pending />
  </div>
</template>

<script setup lang="ts">
import OnboardingChart from './components/OnboardingChart/OnboardingChart.vue'
import OnboardingHelp from './components/OnboardingHelp/OnboardingHelp.vue'

defineProps<{
  requiredTaskAmount: number
  onGoingRequiredTasksAmount: number
  isFetchingPending: boolean
}>()
</script>
